import { useEffect } from 'react'
import { QueryClient } from 'react-query'
import { dehydrate } from 'react-query/hydration'
import Navigation from 'components/navigation'
import PlanetSection from 'home/planet-section'
import PricingSection from 'components/prices/pricing-section'
import { prefetchSubscriptionPlans } from 'querys/subscriptions'
import { prefetchStudentProjects } from 'querys/student-projects'
import { prefetchTotalUsers } from 'querys/growth'
import Testimonies from 'home/testimonies'
import ProjectStudentsHero from 'projects/students/student-projects-hero'
import Footer from 'common/footer'
import { useRouter } from 'next/router'
import StudentProjectsCompleted from 'projects/students/student-projects-completed'
import Divider from 'common/divider'

function StudentProjecs() {
  const { query: { type }, push } = useRouter()

  useEffect(() => {
    if (type === 'outstanding') {
      push('/podium')
    }
  }, [type])

  return (
    <>
      <Navigation position="sticky" maxWidth="1336px" />
      <ProjectStudentsHero
        title="Últimos proyectos de los estudiantes"
        description="Descubre la manera en la que otros estudiantes resuelven proyectos y comparte tu experiencia con la comunidad"
      />
      <StudentProjectsCompleted />
      <Testimonies />
      <PricingSection withUsersCount />
      <Divider color="transparent" marginVertical={64} />
      <PlanetSection />
      <Footer />
    </>
  )
}

export async function getStaticProps() {
  const queryClient = new QueryClient()
  await prefetchTotalUsers({ queryClient })
  await prefetchStudentProjects({ queryClient, page_size: 24 })
  await prefetchSubscriptionPlans({ queryClient, product: 'ALL' })
  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
    revalidate: 3600,
  }
}

export default StudentProjecs
